export interface DataOnboardingState {
  oneSchemaToken: string | null;
  loadingOneSchemaToken: boolean;
  oneSchemaTokenError: string | null;
}

export const FETCH_ONESCHEMA_TOKEN_REQUEST =
  'dataOnboarding/FETCH_ONESCHEMA_TOKEN_REQUEST';
export const FETCH_ONESCHEMA_TOKEN_SUCCESS =
  'dataOnboarding/FETCH_ONESCHEMA_TOKEN_SUCCESS';
export const FETCH_ONESCHEMA_TOKEN_FAILURE =
  'dataOnboarding/FETCH_ONESCHEMA_TOKEN_FAILURE';

interface FetchOneSchemaTokenRequestAction {
  type: typeof FETCH_ONESCHEMA_TOKEN_REQUEST;
}

interface FetchOneSchemaTokenSuccessAction {
  type: typeof FETCH_ONESCHEMA_TOKEN_SUCCESS;
  payload: string; // The token itself
}

interface FetchOneSchemaTokenFailureAction {
  type: typeof FETCH_ONESCHEMA_TOKEN_FAILURE;
  payload: string; // The error message
}

export type DataOnboardingActionTypes =
  | FetchOneSchemaTokenRequestAction
  | FetchOneSchemaTokenSuccessAction
  | FetchOneSchemaTokenFailureAction;
